export default {
  setCredentials: (state, payload) => {            
    localStorage.setItem("sessionState", JSON.stringify(payload));
    state.credentials = JSON.stringify(payload)
  },
  logout: (state) => {   
    localStorage.removeItem("sessionState");
    state.credentials = null;
  }
}